import { InjectionToken } from '@angular/core';
import type { SelectableClientAssignmentsHttpRepository } from '../http/selectable-client-assignments-http.repository';

export const SELECTABLE_CLIENT_ASSIGNMENTS_REPOSITORY_TOKEN =
  new InjectionToken<SelectableClientAssignmentsHttpRepository>(
    'SELECTABLE_CLIENT_ASSIGNMENTS_REPOSITORY_TOKEN'
  );
